var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" * Совет: если автоматически подставленные реквизиты не верны - "),_c('b',{class:_vm.$style.advice,on:{"click":_vm.showOrgDetailsStatement}},[_vm._v("сообщите нам ")])])}
var staticRenderFns = []

export { render, staticRenderFns }